import { InputRestrictionSettings, RoutePermissionSetting } from "@sal/onevent-portal";
import { type Settings as PortalFrameworkSettings } from "@sal/portal-move";

type LayoutSettings = {
	Orientation?: "Vertical" | "Horizontal";
};

const allowedCharacter = String.raw`A-Za-z0-9 !"#$%&'()*+,./:;<=>?@[\\\]^_` + "`" + String.raw`{|}~\-`;

const inputAccept = new RegExp(`[${allowedCharacter}]`, "g");
const multilineInputAccept = new RegExp(`[${allowedCharacter}\\r\\n]`, "g");

type AppSettings = {
	Layout?: LayoutSettings;
	PortalFramework: PortalFrameworkSettings;
	InputRestrictions?: InputRestrictionSettings;
};

const AppSettings: AppSettings = {
	Layout: {
		Orientation: "Vertical"
	},
	InputRestrictions: {
		accept: inputAccept,
		multilineAccept: multilineInputAccept
	},
	PortalFramework: {
		logoUrl: "/images/move_logo.svg",
		loginTitle: "Log into your account",
		defaultColorMode: "system",
		microsoftSsoSettings: {
			enableSso: true,
			clientID: process.env.MICROSOFT_SSO_SETTINGS_CLIENT_ID!,
			authority: process.env.MICROSOFT_SSO_SETTINGS_AUTHORITY!,
			redirectUrl: process.env.MICROSOFT_SSO_SETTINGS_REDIRECT_URL!,
			scopes: ["user.read", "profile"]
		}
	}
} as const;

export default AppSettings;

export const routePermissionMapping: { [key: string]: RoutePermissionSetting } = {
	containerTransportDashboard: {
		path: "/Dashboard",
		securityContext: "apI_ContainerTransportImportFCLOrder",
		securityContextPermission: "Read" //TODO: Update with correct security context and permission
	},
	users: {
		path: "/Users",
		securityContext: "portal_Users",
		securityContextPermission: "Read"
	},
	importFCLTransportOrder: {
		path: "/ImportFCLTransportOrder",
		securityContext: "apI_ContainerTransportImportFCLOrder",
		securityContextPermission: "Read"
	},
	exportFCLTransportOrder: {
		path: "/ExportFCLTransportOrder",
		securityContext: "apI_ContainerTransportExportFCLOrder",
		securityContextPermission: "Read"
	},
	importFAKTransportOrder: {
		path: "/ImportFAKTransportOrder",
		securityContext: "apI_ContainerTransportImportFAKOrder",
		securityContextPermission: "Read"
	},
	exportFAKTransportOrder: {
		path: "/ExportFAKTransportOrder",
		securityContext: "apI_ContainerTransportExportFAKOrder",
		securityContextPermission: "Read"
	},
	importContainer: {
		path: "/ImportContainer",
		securityContext: "apI_ContainerTransportImportContainer",
		securityContextPermission: "Read"
	},
	exportContainer: {
		path: "/ExportContainer",
		securityContext: "apI_ContainerTransportExportContainer",
		securityContextPermission: "Read"
	},
	moveOrder: {
		path: "/MoveOrder",
		securityContext: "apI_ContainerTransportMoveOrder",
		securityContextPermission: "Read"
	},
	moveContainer: {
		path: "/MoveContainer",
		securityContext: "apI_ContainerTransportMoveContainer",
		securityContextPermission: "Read"
	},
	order: {
		path: "/Order",
		permissions: [
			["apI_ContainerTransportImportFCLOrder", "Write"],
			["apI_ContainerTransportImportFAKOrder", "Write"],
			["apI_ContainerTransportExportFCLOrder", "Write"],
			["apI_ContainerTransportExportFAKOrder", "Write"],
			["apI_ContainerTransportMoveOrder", "Write"],
			["apI_ContainerTransportGeneralFreightOrder", "Write"]
		]
	},
	customers: {
		path: "/Customers",
		securityContext: "portal_Contact",
		securityContextPermission: "Web_Customers_Read"
	},
	locations: {
		path: "/Locations",
		securityContext: "portal_Menu",
		securityContextPermission: "Web_Locations"
	},
	codes: {
		path: "/Codes",
		securityContext: "portal_Code",
		securityContextPermission: "Web_Codes_Read"
	},
	generalFreightOrder: {
		path: "/GeneralFreightOrder",
		securityContext: "apI_ContainerTransportGeneralFreightOrder",
		securityContextPermission: "Read"
	},
	newsAndUpdates: {
		path: "/News",
		securityContext: "portal_Menu",
		securityContextPermission: "Web_NewsAndUpdates"
	}
};

// This configure setting control the basic setting of preference form
export const preferenceFormConfigSetting = {
	Currency: { hided: true },
	Home: { hided: true },
	Timezone: { hided: true },
	Distance: { hided: true },
	Weight: { hided: true },
	Size: { hided: true },
	DateFormat: { hided: false, required: false }
};

export const googleMapsLibraries = ["core", "geometry", "maps", "marker"] as const;

export const placesRequestOptions = {
	autocompleteRequestOptions: {
		componentRestrictions: { country: "nz" }
	},
	placeDetailsRequestOptions: {
		fields: ["address_components", "formatted_address", "name", "place_id", "geometry"],
		region: "nz"
	}
};
